module.exports = __webpack_public_path__ + "static/Vaccinating Child-708e0c319d049d3f4210a803f2285279.jpg";